module.exports = __webpack_public_path__ + "img/4.14533808.png";